import React from 'react';
import { Wifi, WifiOff, AlertTriangle } from 'lucide-react';
import { useStabilityEnhancements } from '@/hooks/useStabilityEnhancements';
import { useDemoMode } from '@/contexts/DemoModeContext';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

export const ConnectionStatus: React.FC = () => {
  const { isOnline, isStable } = useStabilityEnhancements();
  const { isDemoMode } = useDemoMode();

  // Never show connection status in demo mode
  if (isDemoMode || (isOnline && isStable)) {
    return null;
  }

  const handleRetry = () => {
    window.location.reload();
  };

  if (!isOnline) {
    return (
      <Alert variant="destructive" className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 max-w-md">
        <WifiOff className="h-4 w-4" />
        <AlertDescription className="flex items-center justify-between">
          <span>You're offline. Some features may not work.</span>
        </AlertDescription>
      </Alert>
    );
  }

  if (!isStable) {
    return (
      <Alert className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 max-w-md">
        <AlertTriangle className="h-4 w-4" />
        <AlertDescription className="flex items-center justify-between">
          <span>Connection unstable</span>
          <Button size="sm" variant="outline" onClick={handleRetry}>
            Retry
          </Button>
        </AlertDescription>
      </Alert>
    );
  }

  return null;
};